import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';

import {
	createNewOrder,
	saveRequestCreditList,
	setRequestCreditDetails,
	updateRequestCreditParams,
	// dropProductSpecsEmail,
} from '../../../../redux/actions';

class RequestCreditAsIsPriceAdjustmentReview extends Component {

	constructor(props) {
		super(props);
		this.state = {
			requestSubmitted: false,
			requestNumber: [],
			creditType: '',
			requestCreditDetails: null,
		};
		this.getLocTypeAccordingToDeliveryMethod = this.getLocTypeAccordingToDeliveryMethod.bind(this);
		this.makeSercondServiceCall = this.makeSercondServiceCall.bind(this);
	}

	getLocTypeAccordingToDeliveryMethod(deliveryMethod) {
		const record = _.find(this.props.order.pickAgentId, {deliveryMethod: deliveryMethod});
		return record && record.loctype ? record.loctype : null;
	}

	componentWillMount() {
		const self = this;
		const { requestCreditDetails, requestCreditFilterListOfOrders } = self.props.order;
		if(!requestCreditDetails) {
			browserHistory.push("/requestcredit");
		} else {
			const creditType = requestCreditFilterListOfOrders && requestCreditFilterListOfOrders.param ? requestCreditFilterListOfOrders.param.creditType: '';
			self.setState({
				creditType,
				requestCreditDetails
			});
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	getDefaultLocType(deliveryMethod) {
		let loctype = '';
		if (deliveryMethod.indexOf('SDS') !== -1) {
			return 'sds_loc';
		} else if (deliveryMethod.indexOf('ADC') !== -1) {
			return 'adc_loc';
		}
		return loctype;
	}

	handleContinue(event) {
		event.preventDefault();
		const self = this;
		const orderDetails = self.state.requestCreditDetails && JSON.parse(JSON.stringify(self.state.requestCreditDetails.responseObject));
		const adjPrdModList = self.props.user.allAdjPrcModList.responseObject;
		const rareCodeSelected = self.state.requestCreditDetails && self.state.requestCreditDetails.rareCodeSelected;
		const { creditType } = self.state;
		let needToCheckReviewApprovalNotes = false, isAnyItemWithNewShouldBePrice = false, isLinePOMissing = false;
		orderDetails.items.forEach(item => {
			if (item.selected) {
				if (item.shouldBePrice !== item.originalShouldBePrice) {
					isAnyItemWithNewShouldBePrice = true;
				}
				if (!item.poNumber.trim() || !item.rebillPONumber.trim()) {
					isLinePOMissing = true;
				}
			}
		})
		if (
			creditType === 'Price Adjustment - Credit/Rebill' && !rareCodeSelected &&
			isAnyItemWithNewShouldBePrice
		) {
			needToCheckReviewApprovalNotes = true;
		}
		// review approval notes is compulsory in case of price adjustment
		if(
			needToCheckReviewApprovalNotes &&
			!orderDetails.reviewApprovalNotes
		) {
			orderDetails.reviewApprovalNotesError = 'error';
			self.setState({
				requestCreditDetails: {
					...self.state.requestCreditDetails,
					responseObject: orderDetails
				}
			});
			window.scrollTo(0, 0);
			return;
		}
		if (isLinePOMissing) {
			self.setState({
				requestCreditDetails: {
					...self.state.requestCreditDetails,
					responseObject: orderDetails
				}
			});
			return;
		}
		orderDetails.creditType=orderDetails.creditType?orderDetails.creditType:self.state.creditType;
		orderDetails.deliveryPhone = orderDetails.deliveryPhone.replace("(", "").replace("-", "").replace(")", "").replace(" ", "");
		orderDetails.items = orderDetails.items.filter(item => item.selected === true);
		orderDetails.poNumber = orderDetails.poNumber.trim();
		orderDetails["adjPrcMod"] = adjPrdModList[0].adjustmentName;
		orderDetails.items.forEach(item => {
			if (item.itemType === "A" && !item.serialNumber) {
				item.serialNumber = 'NA';
			}
			item.quantity = item.returnQuantity;
			item.returnReasonCode = item.reasonCategory;
			// For first service call line type will be creditLine
			item.lineType = 'creditLine';
		});
		let rebillOrderDetails = null;
		let isRebillCallRequired = false;
		if(orderDetails.items.find(itm => itm.accountNumber !== itm.originalAccountNumber)) {
			isRebillCallRequired = true;
			rebillOrderDetails = JSON.parse(JSON.stringify(orderDetails));
			rebillOrderDetails.poNumber = rebillOrderDetails.rebillPONumber;
			delete rebillOrderDetails.rebillPONumber;
		}
		self.setState({
			payload: JSON.parse(JSON.stringify(orderDetails)),
			isRebillCallRequired,
			rebillOrderDetails,
		}, () => {
			const payload = self.state.payload;
			delete payload.rebillPONumber;
			const rebillItems = JSON.parse(JSON.stringify(payload.items));
			// This we are keeping accountnumber and agreement number as it is for credit bill call
			const rareReasonCode = ['Credit Display Model Home Allow Direct Contract Only','Credit Pricing Contract Exception Model Not On Quote','Credit Pricing Contract Late Addition Of Model To Quote','Credit Pricing Contract Price Change On Quote']
			let isRareReasonCodeSelected = false
			payload.items.forEach(item => {
				if(rareReasonCode.includes(item.reasonCategoryLabel)){
					isRareReasonCodeSelected = true;
				}
				item.accountNumber = item.originalAccountNumber;
				item.agreementNumber = item.originalAgreementNumber;
				item.item = item.bkpItem || item.item;
				delete item.rebillPONumber;
			});
			// if no rebill service call required, it means all account number are not changed and kept original then
			// only one service call but need to duplicate items and make those lineType as 'rebillLine'
			if(isRareReasonCodeSelected){
				payload.rareCodeSelected = isRareReasonCodeSelected
			}
			if(!self.state.isRebillCallRequired) {
				const items = JSON.parse(JSON.stringify(rebillItems));
				items.forEach(item => {
					item.lineType = 'rebillLine';
					item.poNumber = item.rebillPONumber.trim();
					delete item.rebillPONumber;
					// keep original agreement number for the the item whose price is taken from subbedmodel
					if (item.subbedModel && item.subbedModelPrice) {
						item.agreementNumber = item.originalAgreementNumber;
						item.agreementName = item.originalAgreementName;
					}
				});
				payload.items = payload.items.concat(items);
			}
			// This call will be for credit
			self.props.createNewOrder(payload, `requestType=requestCredit`, false, response => {
				if(response.status) {
					const requestNumber = self.state.requestNumber;
					requestNumber.push(response.responseObject.orderNumber);
					self.setState({
						requestNumber,
					}, () => {
						// Make second service call if account number and original account number are different.
						// Basically its for rebill
						if(self.state.isRebillCallRequired) {
							const payload = {
								...self.state.rebillOrderDetails,
								deliveryInstructions: response.responseObject.orderNumber,
								shippingAddress: self.state.payload.defaultShipToAddress,
							};
							// For rebill service call line type will be rebillLine
							payload.items.forEach(item => {
								item.lineType = 'rebillLine';
								item.poNumber = item.rebillPONumber.trim();
								delete item.rebillPONumber;
								item.item = item.bkpItem || item.item;
								item.pricingDate = self.state.rebillOrderDetails.creditType = "As-is Credit/Rebill" ? moment().format('MM/DD/YYYY'):item.pricingDate;
								// keep original agreement number for the the item whose price is taken from subbedmodel
								if (item.subbedModel && item.subbedModelPrice) {
									item.agreementNumber = item.originalAgreementNumber;
									item.agreementName = item.originalAgreementName;
								}
							});
							const zipCode = payload.shippingAddress.zip.split('-')[0];
							self.props.getShippingAddressesDetails(zipCode, false, self.getLocTypeAccordingToDeliveryMethod(payload.deliveryMethod), resp => {
								if(payload.shippingAddress.state === 'AK') {
									resp = {
										agentid: "SEA",
										dockcity: "SEATTLE"
									}
								}
								payload.warehouseCode = resp && resp.agentid ? resp.agentid : '';
								if (payload.warehouseCode) {
									self.makeSercondServiceCall(payload);
								} else {
									// if not warhousecode found for the given delivery method then check for default locatype and get warehouse code
									self.props.getShippingAddressesDetails(zipCode, false, self.getDefaultLocType(payload.deliveryMethod), respo => {
										payload.warehouseCode = respo && respo.agentid ? respo.agentid : '';
										self.makeSercondServiceCall(payload);
									});
								}
							});
						} else {
							self.doneWithCall();
						}
					});
				} else {
					browserHistory.push("/error");
				}
			});
		});
	}

	makeSercondServiceCall(payload) {
		const self = this;
		// rebill service call
		self.props.createNewOrder(payload, `requestType=requestCredit`, false, response => {
			if(response.status) {
				const requestNumber = self.state.requestNumber;
				requestNumber.push(response.responseObject.orderNumber);
				self.setState({
					requestNumber,
				}, () => {
					// third service call to set the mapping of delivery instructions
					self.props.createNewOrder({}, `requestType=updateRebillInCredit&creditRef=${requestNumber[0]}&rebillRef=${requestNumber[1]}`, false, response => {
						if(response.status && response.responseObject) {
							self.doneWithCall();
						} else {
							browserHistory.push("/error");
						}
					});
					self.doneWithCall();
				});
			} else {
				browserHistory.push("/error");
			}
		});
	}

	doneWithCall() {
		const self = this;
		self.setState({
			requestSubmitted: true
		});
		self.props.setRequestCreditDetails(null);
		self.props.saveRequestCreditList(null);
		self.props.updateRequestCreditParams(null);
		// if(self.state.creditType === 'Price Adjustment - Credit/Rebill') {
		// 	const { requestNumber, payload } = self.state;
		// 	const { email } = self.props.user.userDetails;
		// 	const emailPayload = {
		// 		email,
		// 		referenceNumber: requestNumber.join(', '),
		// 		account: self.props.getSelectedAccountNumber(),
		// 		poNumber: payload.poNumber,
		// 		reviewApprovalNotes: payload.reviewApprovalNotes,
		// 	};
		// 	self.props.dropProductSpecsEmail(emailPayload, "emailType=requestCredit", response => {
		// 		if(!response.status) {
		// 			self.setState({
		// 				errorMessage: 'Error in sending email. Please contact customer service.'
		// 			});
		// 		}
		// 	});
		// }
	}

	calculateSum(items) {
		let totalSum = 0;
		items.forEach(item => {
			if(item.selected) {
				totalSum += parseFloat(item.creditAmount);
			}
		});
		return this.props.formatAmount2Decimal(totalSum);
	}

	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}

	onChangeUpdateParam(event) {
        const self = this;
		self.setState({
			requestCreditDetails: {
				responseObject: {
					...self.state.requestCreditDetails.responseObject,
					[event.target.name]: event.target.value,
					reviewApprovalNotesError: event.target.name === 'reviewApprovalNotes' ? '' : self.state.requestCreditDetails.responseObject.reviewApprovalNotesError,
				}
			}
        });
    }

	handleLineItemChange = (itemIndex, e) => {
		const { name: fieldName, value: fieldValue } = e.target;
		this.setState({
			requestCreditDetails: {
				...this.state.requestCreditDetails,
				responseObject: {
					...this.state.requestCreditDetails.responseObject,
					items: this.state.requestCreditDetails.responseObject.items.map((item, index) => {
						if (index === itemIndex) {
							const updatedItem = { ...item, [fieldName]: fieldName === 'poNumber' || fieldName === 'rebillPONumber' ? fieldValue.toUpperCase() : fieldValue };
							if (updatedItem[fieldName + 'Error']) {
								updatedItem[fieldName + 'Error'] = ''
							}
							return updatedItem;
						}
						return item;
					})
				}
			}
		})
	}

    render() {
		const self = this;
		const { creditType } = self.state;
		const { userDetails } = self.props.user;
		const orderDetails = self.state.requestCreditDetails && self.state.requestCreditDetails.responseObject;
		const billingAddress = orderDetails && orderDetails.billingAddress;
	    const rareCodeSelected = self.state.requestCreditDetails && self.state.requestCreditDetails.rareCodeSelected;
		const isRestocking = orderDetails && orderDetails.items.filter(item => (item.item === 'RESTOCKING FEE' && self.state.creditType === 'Delivery/Services/Fees' && userDetails.typeOfUser == 'employee')).length > 0? true : false;
        return (
			<div className='container'>
				<div className="d-none d-sm-block">
					{this.state.requestSubmitted && <p className="textRight">
						<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Confirmation of Credit Request</a>
					</p>}
					<div className="smallPush">
						{this.state.requestSubmitted
							?<h1 className="pageTitle">CONFIRMATION OF CREDIT REQUEST</h1>
							:<h1 className="pageTitle">REVIEW CREDIT REQUEST</h1>
						}
						{this.state.requestSubmitted
							?<div>
								{userDetails.typeOfUser === 'customer'
									?<p>The following request for credit has been submitted and will be reviewed for approval. Go to View Returns & Credits to view the status.</p>
									:<p>Thank you for Booking your credit. Go to View Returns & Credits to view the status. Booking may take up to an hour. The Credit Reference # below can be used to search for this return in View Returns & Credits.</p>
								}
							</div>
							:null
						}
						{this.state.requestSubmitted
							?<p><b>Credit Reference #:</b> {this.state.requestNumber.join(', ')}</p>
							:null
						}
						<p><b>Account #:</b> {orderDetails && orderDetails.accountNumber}</p>
					</div>
					{this.state.errorMessage && <p className="red bold">{this.state.errorMessage}</p>}
					<div className="smallPush">
						<div className="columns width100per reviewCreditRequestColumns">
							<div className="column column1">
								<p>
									<b>Bill To:</b>
									<br />
									{billingAddress && <span>
										{billingAddress.addressName && billingAddress.addressName.trim()}
										{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
										{billingAddress.address1  && billingAddress.address1.trim()}, {billingAddress.address2 && billingAddress.address2.trim()} <br/>
										{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()}, {billingAddress.zip && billingAddress.zip.trim()}<br />
										{billingAddress.phone}
									</span>}
								</p>
							</div>
							<div className="column column1">
								{creditType === 'Price Adjustment - Credit/Rebill'
									? (this.state.requestSubmitted
										? <p><b>Review/Approval Notes:</b> {orderDetails && orderDetails.reviewApprovalNotes}</p>
										: (!rareCodeSelected ? <div>
											<span className="bold">Enter notes for Review/Approval:</span>
											<textarea className={orderDetails.reviewApprovalNotesError}  maxLength={186} rows={6} cols={40} name="reviewApprovalNotes" value={orderDetails.reviewApprovalNotes} onChange={this.onChangeUpdateParam.bind(this)} />
										</div>
										: <div></div>))
									: null
								}
								{this.state.requestSubmitted && <p><b>Credit Reason:</b> {orderDetails && orderDetails.items.find(itm => itm.selected).reasonCategoryLabel}<br /></p>}
							</div>
						</div>
					</div>
					<div className="smallPush">
						<div className="columns width100per reviewCreditRequestColumns">
							<div className="column column1">
								<p>
									<b>Credit Request Entered By:</b> {this.props.user.userDetails.firstName} {this.props.user.userDetails.lastName}<br />
									<b>Credit Request Entered On:</b> {moment().format('MM/DD/YY')}<br />
									<b>Credit Type:</b> {this.state.creditType}
								</p>
							</div>
							<div className="column column1">
								<p>
									<b>Contact Phone:</b> {orderDetails && orderDetails.deliveryPhone}<br />
									<b>Credit Invoice Notes:</b> {orderDetails && orderDetails.creditInvoiceNotes}<br />
								</p>
							</div>
						</div>
					</div>
					<div className="push">
						<h2>Original CSO (Order number): {orderDetails && orderDetails.originalOrderNumber}</h2>
						<h2>CREDIT</h2>
						<table className="invoicePrintView" style={{marginBottom: '-14px'}} cellPadding={0} cellSpacing={0} width="100%">
							<tbody>
								<tr>
									<th>Product #</th>
									<th className="text-center">Credit<br/>Request<br/>Quantity</th>
									<th>Original<br/>Invoice #</th>
									<th>Serial Number(s)</th>
									<th>Account Number</th>
									<th>Sales Agreement</th>
									<th>PO</th>
									<th className="text-center">Original<br/>Price<br/>(Each)</th>
									<th className="text-center">Credit<br/>Amount<br/>(Each)</th>
								</tr>
								{orderDetails && orderDetails.items && orderDetails.items.map((item, index) => {
									if(item.selected)
										return [<tr key={index}>
											<td><b>{item.item}</b></td>
											<td>{item.returnQuantity}</td>
											<td>{item.invoiceNumber}</td>
											<td>{item.serialNumber}</td>
											<td>{item.originalAccountNumber}</td>
											<td>{item.originalAgreementNumber}</td>
											<td>
												{this.state.requestSubmitted ? item.poNumber : <input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.handleLineItemChange.bind(this, index), undefined, undefined)} className={'txt-uppercase' + (item.poNumber.trim() ? '' : ' error')} type="text" name="poNumber" onChange={this.handleLineItemChange.bind(this, index)} value={item.poNumber} maxLength={50} />}
											</td>
											<td className="text-right">{this.props.formatAmount2Decimal(item.price)}</td>
											<td className="text-right">{this.props.formatAmount2Decimal(item.creditAmount)}</td>
										</tr>]
									return null;
								})}
								<tr className="invoiceTotals">
									<td className="no-border-btm" colSpan={ 8 }>&nbsp;</td>
								</tr>
								{/* <tr className="invoiceTotals">
									<td>Total</td>
									<td colSpan={ 6 }>&nbsp;</td>
									<td className="text-right">{orderDetails && this.calculateSum(orderDetails.items)}</td>
								</tr>*/}
							</tbody>
						</table>
						<br/>
						<h2>REBILL</h2>
						<table className="invoicePrintView" style={{marginBottom: '-14px'}} cellPadding={0} cellSpacing={0} width="100%">
							<tbody>
								<tr>
									<th>Product #</th>
									<th className="text-center">Credit<br/>Request<br/>Quantity</th>
									<th>Account Number</th>
									<th>Sales Agreement</th>
									<th>PO</th>
									<th className="text-center">Rebill<br/>Amount<br/>(Each)</th>
								</tr>
								{orderDetails && orderDetails.items && orderDetails.items.map((item, index) => {
									if(item.selected)
										return [<tr key={index}>
											<td><b>{item.item}</b></td>
											<td>{item.returnQuantity}</td>
											<td>{`${item.accountNumber} - ${item.accountDescription}`}</td>
											<td>{item.agreementName}</td>
											<td>
												{this.state.requestSubmitted ? item.rebillPONumber : <input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.handleLineItemChange.bind(this, index), undefined, undefined)} className={'txt-uppercase' + (item.rebillPONumber.trim() ? '' : ' error')} type="text" name="rebillPONumber" onChange={this.handleLineItemChange.bind(this, index)} value={item.rebillPONumber} maxLength={50} />}
											</td>
											<td className="text-right">{this.props.formatAmount2Decimal(item.shouldBePrice)}</td>
										</tr>]
									return null;
								})}
								<tr className="invoiceTotals">
									<td className="no-border-btm" colSpan={ 8 }>&nbsp;</td>
								</tr>
								{/* <tr className="invoiceTotals">
									<td>Total</td>
									<td colSpan={ 6 }>&nbsp;</td>
									<td className="text-right">{orderDetails && this.calculateSum(orderDetails.items)}</td>
								</tr> */}
							</tbody>
						</table>
					</div>
					{this.state.requestSubmitted
						?null
						:<div>
							<div className="columns">
								<div className="column">
									<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
								</div>
								<div className="column textRight">
									<input type="submit" onClick={this.handleContinue.bind(this)} value="Submit Request" />
								</div>
							</div>
							<div style={{display:"flex",paddingTop:"1%"}}>
								<a href="" onClick={(e) => this.handleGoToStep('/requestCreditAsIsPriceAdjustment', e)} className="bold">Return to previous screen</a>
								{ isRestocking ? <div className="push" style={{ textAlign: 'right' }}>
								<p className="bold red" style={{ marginTop: '1px' }}>All Restocking that is credited will be billed to the Region.</p>
							</div> : null}
							</div>
						</div>
					}
				</div>

				{/*Mobile view*/}

				<div className="d-block d-sm-none container">

					<div className="smallPush mt-3">
						{this.state.requestSubmitted
							?<h1 className="pageTitle">CONFIRMATION OF CREDIT REQUEST</h1>
							:<h1 className="pageTitle">REVIEW CREDIT REQUEST</h1>
						}
					</div>

					{this.state.requestSubmitted && <div>
						
							<div>
								{userDetails.typeOfUser === 'customer'
									?<p>The following request for credit has been submitted and will be reviewed for approval. Go to View Returns & Credits to view the status.</p>
									:<p>Thank you for Booking your credit. Go to View Returns & Credits to view the status. Booking may take up to an hour. The Credit Reference # below can be used to search for this return in View Returns & Credits.</p>
								}
							</div>
						</div>
					}				

					{
						this.state.requestSubmitted && <div>
							<p><b>Credit Reference #:</b> {this.state.requestNumber.join(', ')}</p>
						</div>
					}
					<div className=' mt-3'>
						<div className='col-12 fw-bold'>
								Account #:
						</div>
						<div className='col-12'>
							{orderDetails && orderDetails.accountNumber}
						</div>
					</div>

					<div className=' mt-3'>
						{this.state.errorMessage && <p className="red bold">{this.state.errorMessage}</p>}
					</div>

					<div className=' mt-3'>
							<div className='col-12 fw-bold'>
								Bill To:
							</div>
							{billingAddress && 
								<div className='col-12'>
							<p className="billingAddress">
								{billingAddress && <span>
									{billingAddress.addressName && billingAddress.addressName.trim()}
									{billingAddress.addressName && billingAddress.addressName.trim() !== ""?<br/>:null}
									{billingAddress.address1  && billingAddress.address1.trim()}, {billingAddress.address2 && billingAddress.address2.trim()} <br/>
									{billingAddress.city && billingAddress.city.trim()}, {billingAddress.state && billingAddress.state.trim()}, {billingAddress.zip && billingAddress.zip.trim()}<br />
									{billingAddress.phone}
								</span>}
							</p>

							</div>}
					</div>

					<div className=' mt-3'>
						{creditType === 'Price Adjustment - Credit/Rebill'
								? (this.state.requestSubmitted
									? <p><b>Review/Approval Notes:</b> {orderDetails && orderDetails.reviewApprovalNotes}</p>
									: (!rareCodeSelected ? <div>
										<span className="bold">Enter notes for Review/Approval:</span>
										<textarea className={orderDetails.reviewApprovalNotesError}  maxLength={186} rows={6} cols={40} name="reviewApprovalNotes" value={orderDetails.reviewApprovalNotes} onChange={this.onChangeUpdateParam.bind(this)} />
									</div>
									: <div></div>))
								: null
							}
					</div>

					{this.state.requestSubmitted && 
						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
								Credit Reason:
							</div>
							<div className='col-12'>
								{orderDetails && orderDetails.items.find(itm => itm.selected).reasonCategoryLabel}
							</div>
						</div>
					}

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Request Entered By:
							</div>
							<div className='col-12'>
							{this.props.user.userDetails.firstName} {this.props.user.userDetails.lastName}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Request Entered On:
							</div>
							<div className='col-12'>
							{moment().format('MM/DD/YY')}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Type:
							</div>
							<div className='col-12'>
							{this.state.creditType}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Contact Phone:
							</div>
							<div className='col-12'>
							{orderDetails && orderDetails.deliveryPhone}
							</div>
						</div>

						<div className=' mt-3'>
							<div className='col-12 fw-bold'>
							Credit Invoice Notes:
							</div>
							<div className='col-12'>
							{orderDetails && orderDetails.creditInvoiceNotes}
							</div>
						</div>

						{this.state.requestSubmitted && <div className=' mt-3'>
							<div className='col-8'>
							<button className="bold uppercase" onClick={this.props.handlePrint} >Print Confirmation of Credit Request</button>
						</div>
					</div>}

						<div className='container headerColor captionContainerSingleLine'>
							<div className='row d-flex align-items-center'>
									<b>Original CSO (Order number): {orderDetails && orderDetails.originalOrderNumber}</b>
							</div>
						</div>

						<div className=' headerColor1 captionContainerSingleLine'>
							<div className='row d-flex align-items-center fw-bold'>
									CREDIT
							</div>
						</div>

						{orderDetails && orderDetails.items && orderDetails.items.map((item, index) => {
								if(item.selected)
								return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStep6a${index}`}  key={index}>
								<div className="accordion-item">

									<h2 className="accordion-header" id={`headingRequestReturnCreditStep6a${index}`}>
										<div className=''>
											<div className='row accBtn'>
												<div className='col-12'>
													<button className="accBtn accordion-button  font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseRequestReturnCreditStep6a${index}`} aria-expanded="true" aria-controls={`collapseRequestReturnCreditStep4${index}`}>
														{`Product ${item.item}`} 
													</button>
												</div>
											</div>
										</div>
									</h2>	

									<div id={`collapseRequestReturnCreditStep6a${index}`}
														className={`accordion-collapse collapse accBody show`} 
														aria-labelledby={`headingRequestReturnCreditStep6a${index}`}
														show>

										<div className="">
											
										<div className="row ">
												<div className="col-8 fw-bold pt-4">Credit Request Quantity</div>
												<div className="col-4 text-end pt-4">
													{item.returnQuantity}
												</div>
												<hr className="hr hrSpec" />
										</div>

										
										
											<div className="row ">
												<div className="col-8 fw-bold">Original Invoice #</div>
												<div className="col-4 text-end">{item.invoiceNumber}</div>
												<hr className="hr hrSpec" />
											</div>

											<div className="row ">
												<div className="col-6 fw-bold">Serial Number(s)</div>
												<div className="col-6 text-end">{item.serialNumber}</div>
												<hr className="hr hrSpec" />
											</div>

											<div className="row ">
												<div className="col-6 fw-bold">Account Number</div>
												<div className="col-6 text-end">{item.originalAccountNumber}</div>
												<hr className="hr hrSpec" />
											</div>

											<div className="row">
												<div className="col-8 fw-bold">Sales Agreement</div>
												<div className="col-4 text-end">{item.originalAgreementNumber}</div>
												<hr className="hr hrSpec" />	
											</div>

											<div className="row">
												<div className="col-8 fw-bold">PO</div>
												<div className="col-4 text-end">
													{this.state.requestSubmitted ? item.poNumber : <input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.handleLineItemChange.bind(this, index), undefined, undefined)} className={'txt-uppercase' + (item.poNumber.trim() ? '' : ' error')} type="text" name="poNumber" onChange={this.handleLineItemChange.bind(this, index)} value={item.poNumber} maxLength={50} />}
												</div>
												<hr className="hr hrSpec" />	
											</div>

											<div className="row ">
												<div className="col-8 fw-bold">Original Price (Each)</div>
												<div className="col-4 text-end">{this.props.formatAmount2Decimal(item.price)}</div>
												<hr className="hr hrSpec" />
											</div>

											<div className="row mb-3">
												<div className="col-8 fw-bold">Credit Amount (Each)</div>
												<div className="col-4 text-end">{this.props.formatAmount2Decimal(item.creditAmount)}</div>
											</div>
										</div>
									</div>
								</div>
							</div>

									return null;
							})}

						<div className=' headerColor1 captionContainer'>
							<div className='row d-flex align-items-center fw-bold'>
							REBILL
							</div>
						</div>

						{orderDetails && orderDetails.items && orderDetails.items.map((item, index) => {
								if(item.selected)
									return <div className="accordion removeAccBorder accordion-borderless" id={`accordionRequestReturnCreditStepRebil6a${index}`}  key={index}>
								<div className="accordion-item">

									<h2 className="accordion-header" id={`headingRequestReturnCreditStepRebil6a${index}`}>
										<div className=''>
											<div className='row accBtn'>
												<div className='col-12'>
													<button className="accBtn accordion-button  font-size-14 collapsed " type="button" data-bs-toggle="collapse" data-bs-target={`#collapseRequestReturnCreditStepRebil6a${index}`} aria-expanded="true" aria-controls={`collapseRequestReturnCreditStep4${index}`}>
														{`Product ${item.item}`} 
													</button>
												</div>
											</div>
										</div>
									</h2>	

									<div id={`collapseRequestReturnCreditStepRebil6a${index}`}
														className={`accordion-collapse collapse accBody show`} 
														aria-labelledby={`headingRequestReturnCreditStepRebil6a${index}`}
														show>

										<div className="">
											
										<div className="row ">
												<div className="col-8 fw-bold pt-4">Credit Request Quantity</div>
												<div className="col-4 text-end pt-4">
													{item.returnQuantity}
												</div>
												<hr className="hr hrSpec" />
										</div>

											<div className="row ">
												<div className="col-6 fw-bold">Account Number</div>
												<div className="col-6 text-end">{`${item.accountNumber} - ${item.accountDescription}`}</div>
												<hr className="hr hrSpec" />
											</div>

											<div className="row">
												<div className="col-8 fw-bold">Sales Agreement</div>
												<div className="col-4 text-end">{item.originalAgreementNumber}</div>
												<hr className="hr hrSpec" />	
											</div>

											<div className="row">
												<div className="col-8 fw-bold">PO</div>
												<div className="col-4 text-end">
													{this.state.requestSubmitted ? item.rebillPONumber : <input onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.handleLineItemChange.bind(this, index), undefined, undefined)} className={'txt-uppercase' + (item.rebillPONumber.trim() ? '' : ' error')} type="text" name="rebillPONumber" onChange={this.handleLineItemChange.bind(this, index)} value={item.rebillPONumber} maxLength={50} />}
												</div>
												<hr className="hr hrSpec" />	
											</div>

											<div className="row mb-3">
												<div className="col-8 fw-bold">Rebill Amount (Each)</div>
												<div className="col-4 text-end">{this.props.formatAmount2Decimal(item.shouldBePrice)}</div>
											</div>
										</div>
									</div>
								</div>
							</div>

									return null;
							})}

{this.state.requestSubmitted
						?null :
						<div>
						<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							<span>
								<button id="continueButton" className='submitBtnSize' onClick={this.handleContinue.bind(this)}>Submit Request</button>
							</span>
						</div>
					

					<div className="container mt-4 backLink">
						<a href="" onClick={(e) => this.handleGoToStep('/requestCreditAsIsPriceAdjustment', e)} className="bold">Return to previous screen</a>
					</div>

					{ isRestocking ? <div className="push" style={{ textAlign: 'right' }}>
				 			<p className="bold red" style={{ marginTop: '1px' }}>All Restocking that is credited will be billed to the Region.</p>
						</div> : null}
					</div>
}
<div style={{height:"200px"}}></div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	saveRequestCreditList: (requestCreditList) => dispatch(saveRequestCreditList(requestCreditList)),
	setRequestCreditDetails: (data) => dispatch(setRequestCreditDetails(data)),
	updateRequestCreditParams: (data) => dispatch(updateRequestCreditParams(data)),
	// dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
});

RequestCreditAsIsPriceAdjustmentReview = connect(mapStateToProps, mapDispatchToProps)(RequestCreditAsIsPriceAdjustmentReview);
export default RequestCreditAsIsPriceAdjustmentReview;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditAsIsPriceAdjustmentReview.js